// components/LoadingSkeleton.js
import React from 'react';
import { Box, Skeleton } from '@mui/material';

const LoadingSkeleton = () => {
  return (
    <Box sx={{ width: '100%', padding: 3 }}>
      <Skeleton variant="rectangular" width="100%" height={300} sx={{ mb: 2 }} />
      <Skeleton variant="text" width="60%" height={40} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="80%" height={30} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="80%" height={30} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="80%" height={30} sx={{ mb: 1 }} />
      <Skeleton variant="rectangular" width="100%" height={200} sx={{ mb: 2 }} />
      <Skeleton variant="text" width="60%" height={40} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="80%" height={30} sx={{ mb: 1 }} />
    </Box>
  );
};

export default LoadingSkeleton;